import type { CompRef } from '@wix/document-services-types';
import type { PluginPlacement } from '@wix/ambassador-devcenter-appsruntimereader-v1-app-runtime-data/types';
import { InstallationOriginType } from '@wix/editor-platform-sdk-types';

export interface PluginInfo {
  widgetId: string;
  appDefinitionId: string;
  name: string;
  description: string;
  logoUrl: string;
}

export interface WidgetSlot {
  compRef: CompRef; // need to remove after we fully migrate from placements
  interfaces?: string[];
  role: string;
  placement: PluginPlacement;
  hostCompRef: CompRef;
  id?: string; // optional untill we fully migrate from placements
  pluginInfo?: PluginInfo;
}

export interface WidgetSlotPosition {
  y: number;
  height: number;
}

export interface WidgetPointer {
  appDefinitionId: string;
  widgetId: string;
  version?: string;
}

export interface WidgetSlotToMoveContent {
  slotRef: CompRef;
  pluginInfo: PluginInfo | undefined;
  name: string | undefined;
  isPopulated: boolean;
  isSelected: boolean;
}

export enum PluginsEditorType {
  Classic = 'classic',
  Responsive = 'editorx',
  Studio = 'studio',
  Blocks = 'blocks',
  Editor3 = 'editor3',
}

type PluginInstallationOrigin =
  | 'unknown'
  | 'sdk'
  | 'keyboard'
  | 'appMarket'
  | 'contextMenu'
  | 'pluginsPanel'
  | 'blocksAppEditor'
  | 'plugin_manage_card'
  | 'plugin_market_card'
  | 'plugin_market_card_replace'
  | InstallationOriginType;

type PluginControlMode = 'user' | 'application';

// needed for imlementation of install / uninstall or autoinstall services
export type PluginActionContext = {
  biOrigin: PluginInstallationOrigin;
  controlMode: PluginControlMode;
};

export interface SlotDefinition {
  id: string;
  displayName: string;
  name: string;
  isPublic: boolean;
  appDefinitionId: string;
  widgetId: string;
  blocksSlotRefId?: string; // only for blocks slots
  innerElementPath?: string[]; // only for builder slots
}

// represents a slot in the builder, blocks or OOI host widget
export interface UniversalSlotPointer {
  hostCompRef: CompRef;
  slotId: string;
}

export enum PluginInstallationError {
  Fail = 'Fail',
  ConsentCancel = 'ConsentCancel',
  ConsentClose = 'ConsentClose',
}
